const container = document.getElementById('locationResults');
const listViewButton = document.getElementById('listViewButton');
const filterEdit = document.getElementById('editFilter');
const filterDone = document.getElementById('filterDone');
const filterSet = document.getElementById('filterSet');
const filterInput = document.getElementById('filterInput');
const mapViewButton = document.querySelectorAll('#mapViewButton');
const viewHours = document.querySelectorAll('#viewHours');



if (listViewButton != null) {
    listViewButton.addEventListener('click', () => {
        container.classList.add('list-view');
    })
}

if (mapViewButton != null) {
    mapViewButton.forEach((item) => {
        item.addEventListener('click', () => {
            container.classList.remove('list-view');
        })
    });
}



if (viewHours != null) {
    viewHours.forEach((item) => {
        item.addEventListener('click', (event) => {
            var openedItem = document.querySelector('.open-list');
            if (item.parentElement.classList.contains('open-list')) {
                item.parentElement.classList.remove('open-list');
            } else if (openedItem != null) {
                openedItem.classList.remove('open-list');
                item.parentElement.classList.add('open-list');
            } else {
                item.parentElement.classList.add('open-list');
            }
        })
    });
}

if (filterEdit != null) {
    filterEdit.addEventListener('click', () => {
        filterSet.classList.add('hide');
        filterSet.classList.remove('show');
        filterInput.classList.add('show');
        filterInput.classList.remove('hide');
    })
}

if (filterDone != null) {
    filterDone.addEventListener('click', () => {
        filterSet.classList.add('show');
        filterSet.classList.remove('hide');
        filterInput.classList.add('hide');
        filterInput.classList.remove('show');
    })
}